import { FETCH_PROMOTES } from '../actions/promote';


export const initialState = {
    isFetching: true,
    data: null
};

export const promotes = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_PROMOTES}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_PROMOTES}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                searchParams: action.meta.searchParams,
                data: action.payload.data,
            });
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/promote.js